import { http, HttpResponse } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';

const URL = `${BASE_URL_V2}${API.endpoints.tour}/:id`;

export const updateTourHandler = http.put(URL, ({ params }) => {
    const { id } = params;
    return HttpResponse.json({
        tourId: id,
        status: 'updated',
    });
});
